import { axiosPrivate } from "./axios";

/**
 * Monthly Report API
 * - Load from snapshot if month is saved, else computed live.
 * - Select by month and optional week.
 */

const monthlyReportService = {
  /**
   * Get report for a month (and optional week).
   * @param {number} year
   * @param {number} month - 1-12
   * @param {number|null} week - 1-5 or null for full month
   * @returns {Promise<{ source: 'snapshot'|'computed', year, month, week?, data: Array }>}
   */
  getReport: async (year, month, week = null) => {
    const params = { year, month };
    if (week != null) params.week = week;
    const response = await axiosPrivate.get("/api/monthly-reports", { params });
    return response.data;
  },

  /**
   * Check if a snapshot exists for the given month.
   * @param {number} year
   * @param {number} month - 1-12
   */
  checkSnapshot: async (year, month) => {
    const response = await axiosPrivate.get("/api/monthly-reports/check", {
      params: { year, month },
    });
    return response.data;
  },

  /**
   * Manually generate and save snapshot for a month (admin).
   * @param {number} year
   * @param {number} month - 1-12
   */
  generateSnapshot: async (year, month) => {
    const response = await axiosPrivate.post("/api/monthly-reports/generate", {
      year,
      month,
    });
    return response.data;
  },
};

export default monthlyReportService;
